import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { IconTime } from '../../../../../../../assets/icons';
import { useHold } from '../../../../../../../hooks/interaction/use-hold';
import { timeFormatted } from '../../../../../../../utils/helpers';
import './index.scss';

type TimeActivationButtonProps = {
  value: number;
  onClick?: () => void;
  onHold?: () => void;
  active?: boolean;
};

export const TimeActivationButton: React.FC<TimeActivationButtonProps> = ({
  value,
  onClick,
  onHold,
  active = false,
}) => {
  const { t } = useTranslation('action');

  const attributes = onHold
    ? useHold({
        holdMillisecond: 1000,
        onClick,
        onHold,
      })
    : { onClick };

  const valueConverted = timeFormatted(value, t);

  return (
    <button
      {...attributes}
      className={classNames('time-activation-button', 'button', 'button--invert', {
        active,
      })}
    >
      <IconTime />
      <span className="time-activation-button__value">{valueConverted}</span>
    </button>
  );
};
